import React from 'react';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-primary-dark text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4">Grassroots Mobilization<br />for APC PBAT Nationwide</h3>
            <p className="text-gray-300 mb-6 max-w-md">
              Empowering communities, strengthening unity, and driving progress across Nigeria through dedicated grassroots engagement.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-accent transition-colors"><Facebook /></a>
              <a href="#" className="hover:text-accent transition-colors"><Twitter /></a>
              <a href="#" className="hover:text-accent transition-colors"><Instagram /></a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white transition-colors">Home</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-white transition-colors">About Us</a></li>
              <li><a href="#leadership" className="text-gray-300 hover:text-white transition-colors">Leadership</a></li>
              <li><a href="#events" className="text-gray-300 hover:text-white transition-colors">Events</a></li>
              <li><a href="#join" className="text-gray-300 hover:text-white transition-colors">Join Us</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0" />
                <span className="text-gray-300">APC National Secretariat, Abuja, Nigeria</span>
              </li>
              <li className="flex items-start space-x-3">
              <Phone className="w-5 h-5 flex-shrink-0 mt-1" />
              <div className="text-gray-300 flex flex-col">
                <span>+2347044411111</span>
                <span>+2347063656162</span>
                <span>+2348188675284</span>
                <span>+2348123354112</span>
              </div>
            </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 flex-shrink-0" />
                <span className="text-gray-300"></span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Grassroots Mobilization for APC PBAT Nationwide (BOT). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
